import './dashboard_results_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.DashboardPreviewResultsView extends Monitoring.Views.DashboardResultsView
  template: JST["backbone/templates/monitoring/dashboard_preview_results"]

  events:
    'click #clone': '_cloneDashboard'

  initialize: (@options = {}) ->
    super(@options)
    @facets = @options.facets
    @editable = if _.isBoolean(@options.editable) then @options.editable else true

  _cloneDashboard: ->
    @eventAggregator.trigger('clickOnCloneDashboard', @searchQuery)
    @hide()

  show: ->
    @$el.find('#preview').modal()

  hide: ->
    @$el.find('#preview').modal('hide')

  render: ->
    @$el.html @template readonly: not @editable
    @$resultsContainer = @$el.find('#current_results')
    return this

  setSearchQuery: (searchQuery) ->
    @searchQuery = searchQuery

  newSearch: ->
    @hide()
    @searchQuery.resetCounter()
    @$resultsContainer.empty()
    @searchWith('charts/preview', false)
    @show()
    @$el.find('#preview').addClass('processing')

  handleQueryResults: (dashboardResults, new_search) =>
    @isDrillDownMode = true
    _.each(dashboardResults.values, (content) => @markAsDrillDown(content))
    @$el.find('#preview').removeClass('processing')
    super(dashboardResults, new_search, @$resultsContainer)
    @$resultsContainer.removeClass('processing')
    @disable_user_profile_modal()
    if dashboardResults.values.length == 0
      @$resultsContainer.append('<p><b>' + @noResultsMessage() + '</b></p>')
    else
      @formatResults()

  noResultsMessage: ->
    'NO RESULTS'

  disable_user_profile_modal: ->
    @$el.find('.user-profile-links').attr('class', 'unbindUserProfileClass')

  markAsDrillDown: (content)->
    content['isDrillDownMode']= @isDrillDownMode || false


  formatResults: ->
    # format may be changed by subclasses

  addOne: (socialContent, allTags, addFunction) =>
    unless allTags
      allTags = []
      console.log("Warning: allTags was undefined for content " + socialContent + ", replaced with []")
    view = Monitoring.Views.SocialContentViewFactory.create(socialContent, allTags)
    @addAndApplyEffect(view, addFunction) if view

  updateResults: ->

  destroy: ->
    @remove()
